import { prepareHeaders } from '~/api/common/prepareHeaders';
import { BaseQueryFn, FetchArgs, fetchBaseQuery, FetchBaseQueryError } from '@reduxjs/toolkit/query/react';
import {
    getDeviceManagementBackend,
    getLogsBackend
} from '~/features/base/selectors/backendSelectors';
import { shouldDispatchSessionExpired, markSessionExpired } from '~/features/login/sessionExpiredGuard';
import { notifyPermissionDenied } from '~/features/base/actions/notificationActions';
import { userSessionExpired } from '~/features/login/actions';

const getRequestUrl = (args: string | FetchArgs): string => {
    return typeof args === 'string' ? args : args.url;
};

export const dynamicBaseQuery: BaseQueryFn<string | FetchArgs,
    unknown,
    FetchBaseQueryError> = async(args, api, extraOptions) => {
    const baseUrl = getDeviceManagementBackend(api.getState());
    const result = await fetchBaseQuery(
        {
            baseUrl,
            prepareHeaders
        })(args, api, extraOptions);

    if (result.error?.status === 401) {
        if (shouldDispatchSessionExpired()) {
            markSessionExpired();
            api.dispatch(userSessionExpired());
        }
    }

    if (result.error?.status === 403) {
        api.dispatch(notifyPermissionDenied(getRequestUrl(args)));
    }

    return result;
};

export const dynamicLogBaseQuery: BaseQueryFn<string | FetchArgs,
    unknown,
    FetchBaseQueryError> = async(args, api, extraOptions) => {
    const baseUrl = getLogsBackend(api.getState());
    const result = await fetchBaseQuery(
        {
            baseUrl,
            prepareHeaders
        })(args, api, extraOptions);

    if (result.error?.status === 401) {
        if (shouldDispatchSessionExpired()) {
            markSessionExpired();
            api.dispatch(userSessionExpired());
        }
    }

    if (result.error?.status === 403) {
        api.dispatch(notifyPermissionDenied(getRequestUrl(args)));
    }

    return result;
};
